const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

/**
 * 주소로 좌표를 조회합니다.
 */
export const getCoordinates = async (address: string) => {
  try {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
      address
    )}&key=${GOOGLE_API_KEY}`;

    const response = await fetch(url);
    const data = await response.json();

    console.log("Geocoding Response:", data);

    if (data.results && data.results.length > 0) {
      const { lat, lng } = data.results[0].geometry.location;
      const coordinates = { lat: lat.toString(), lon: lng.toString() };
      console.log("Extracted Coordinates:", coordinates);
      return coordinates;
    }
    return null;
  } catch (error) {
    console.error("좌표 조회 실패:", error);
    return null;
  }
};

/**
 * UTC 날짜를 한국 시간대(KST)로 변환합니다.
 * @param utcDateString UTC 날짜 문자열 (ISO 8601 형식)
 * @returns KST로 변환된 Date 객체
 */
export const convertUTCToKST = (utcDateString: string): Date => {
  if (!utcDateString) {
    return new Date();
  }

  try {
    // UTC 날짜를 Date 객체로 변환
    const utcDate = new Date(utcDateString);

    // 유효하지 않은 날짜인 경우 현재 시간 반환
    if (isNaN(utcDate.getTime())) {
      console.warn('[DATE_CONVERSION]', {
        input: utcDateString,
        message: 'Invalid date string, returning current date',
      });
      return new Date();
    }

    // KST는 UTC+9이므로 9시간(밀리초) 추가
    const kstDate = new Date(utcDate.getTime() + 9 * 60 * 60 * 1000);

    return kstDate;
  } catch (error) {
    console.error('[DATE_CONVERSION_ERROR]', {
      input: utcDateString,
      error: error instanceof Error ? error.message : 'Unknown error',
    });
    return new Date();
  }
};

import { format } from 'date-fns';

/**
 * UTC 날짜를 한국 시간대(KST)로 변환하여 포맷팅합니다.
 * @param utcDateString UTC 날짜 문자열 (ISO 8601 형식)
 * @param formatString date-fns 포맷 문자열 (기본값: "yyyy-MM-dd HH:mm")
 * @returns 포맷된 날짜 문자열
 */
export const formatUTCToKST = (
  utcDateString: string,
  formatString: string = 'yyyy-MM-dd HH:mm',
): string => {
  if (!utcDateString) {
    return '-';
  }

  try {
    const kstDate = convertUTCToKST(utcDateString);
    return format(kstDate, formatString);
  } catch (error) {
    console.error('[DATE_FORMAT_ERROR]', {
      input: utcDateString,
      format: formatString,
      error: error instanceof Error ? error.message : 'Unknown error',
    });
    return '-';
  }
};
